import { createApp } from 'vue';
import Cookie from 'js-cookie';
import CookieConsentApp from './CookieConsentApp.vue';

export function initCookieConsentBlock() {
    const rootEl = document.getElementById('ccnt-app');
    const dataEl = document.getElementById('ccnt-data');
    if (!rootEl || !dataEl) {
        console.warn(`Failed to initialize cookie notice: missing required DOM nodes`);
    }
    try {
        const props = JSON.parse(dataEl.innerText || '{}');

        if (process.env.MIX_WP_ENV === 'development') {
            console.groupCollapsed('Cookie consent');
            console.log(props);
            const cookieStats = Cookie.get(props.state_cookie.key);
            const cookieStatsNice = JSON.parse(atob(cookieStats || '') || '{}');
            console.log('Cookie stats: ', cookieStats, cookieStatsNice);
            console.log('Local storage exp: ', localStorage.getItem('ccnt_required_expiration'));
            console.groupEnd();
        }

        const app = createApp(CookieConsentApp, props);
        app.mount(rootEl);
    } catch (err) {
        console.warn(`Failed to initialize cookie notice due to an error`, err);
    }
}
